export const environment = {
  production: false,
  API_URL_DOMAIN_BACKEND: 'https://er-domain-backend-dev.azurewebsites.net/api',
  API_URL_PERFORMANCE: 'https://er-domain-backend-dev.azurewebsites.net/dev/api/v1',
  API_URL_DOMAIN: 'https://er-domain-backend-dev.azurewebsites.net/api/v1/',
  API_URL_FINANTIAL_MODEL:'https://er-financial-model-calc-ms.azurewebsites.net/api/',
  API_URL_NOTIFICATIONS: 'https://er-notifications-dev-ms.azurewebsites.net/',
  API_URL_AUTH_V1: 'https://er-auth-app.azurewebsites.net/api/v1/realm/dev',
  API_URL_FINANTIAL_MODEL_SOCKET:
    'wss://er-financial-model-calc-ms.azurewebsites.net/api/',
  APP: 'backoffice',
  CUBEJS_TOKEN: 'CUBEJS_TOKEN_PLACEHOLDER',
  CUBEJS_TOKEN_DOMAIN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsImp0aSI6IjEwYTVkMTQyLTQwZmYtNGU4ZS05OWJhLWY4NjE0YmZiNDU4MiIsImRhdGFTb3VyY2UiOiJkb21haW5fZGIiLCJpYXQiOjE3NTIxMDM0NTgsInRlbmFudCI6ImRvbWFpbl9kYiJ9.ptAQ3im3iBxLWK9GiwOcM3Te56kcE4u0CTqXo-mxxbU',
  CUBEJS_TOKEN_FINANZAS: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJhZG1pbiIsImp0aSI6ImQwODAwOGRhLWZjMzUtNGVmNC04ODA1LWU1ZmMzYjc2YmFlZSIsImRhdGFTb3VyY2UiOiJmaW5hbnphc19kYiIsImlhdCI6MTc1MjEwMzQ1OCwidGVuYW50IjoiZmluYW56YXNfZGIifQ.UxdQ92MUxGgctypYs2kwyL24Sv0dC2PN_V2HKm_eGTo',
  CUBEJS_API_URL: 'https://harlequin-bee.aws-us-east-1.cubecloudapp.dev/cubejs-api/v1/',
  GOOGLE_API_KEY: 'AIzaSyAm6X3YpXfXqYdRANKV4AADLZPkedrwG2k',
  TOMORROW_KEY: '5ly8YFL87NUmMvqZBd1QWIyKovbH6uNF',
  CRYPTO_KEY: '4Vx!9H7j@LkP*2qZ$m#F&tWdRp^C!8s',
  ERCDN: 'https://erportal-cdn-gjhbh7fhcbf6fmac.z01.azurefd.net/static-content',
  API_URL_REPORTS: 'https://cloud.energiareal.mx/dev/er-svc-reporting',
  SENTRY_DSN: 'https://423db044ac33403089b70430bfc958cc@glitchtip.energiareal.mx/19',
  SENTRY_ENV: 'development'
};
